import { UploadSource } from "../domain/UploadSource";
import type { UploadSourceModel } from "../../../../OpenApi/api";

export interface IUploadSourceMapper {
    map(uploadSourceInterface: UploadSourceModel): UploadSource;
}

export class UploadSourceMapper implements IUploadSourceMapper {
    map(uploadSourceInterface: UploadSourceModel): UploadSource {
        return new UploadSource(
            uploadSourceInterface.id,
            uploadSourceInterface.description,
            uploadSourceInterface.name,
            uploadSourceInterface.logo,
            uploadSourceInterface.logoStyle,
            uploadSourceInterface.telephone,
            uploadSourceInterface.email,
            uploadSourceInterface.sizeLimitInGb,
        );
    }
}
